<template>
  <div class="tooltip_container">
    <img src="/static/icons/coupon.svg" width="24" height="24" />
    <span class="f_gray_12 body_9">{{ text }}</span>
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String
    }
  }
}
</script>

<style scoped>
.tooltip_container {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  background-color: rgb(40, 42, 46, 0.6);
  border-radius: 24px;
  position: relative;
  width: fit-content;
  margin: 0 auto;
}
.tooltip_container::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0px 5px 10px 5px;
  border-color: transparent transparent rgb(40, 42, 46, 0.6) transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiTooltip.vue